export const kpiOwnersStoreKey = 'kpiOwners';
